import { MutationTree } from 'vuex';
import { State } from '@/store/modules/cloud/detail/detail.store';

const mutations: MutationTree<State> = {
  setCurrentService(state, params) {
    state.currentService = params;
  },

  setCurrentServiceInstances(state, params) {
    if (state.currentServiceInstance.includes(params)) {
      const index = state.currentServiceInstance.indexOf(params);

      state.currentServiceInstance.splice(index, 1);
    } else {
      state.currentServiceInstance.push(params);
    }
  },

  setCurrentPage(state: State, data: any) {
    state.currentPage = data;
  },

  setCurrentServiceInstance(state, newServiceInstnaces) {
    state.currentServiceInstance = newServiceInstnaces;
  },

  setCurrentSubType(state, data) {
    state.currentSubType = data;
  },

  setCurrentServices(state, data) {
    state.currentServices = data;
  },

  setCurrentTab(state, data) {
    state.currentTab = data;
  },

  setClusterLabels(state, data) {
    state.clusterLabels = data;
  },
};

export default mutations;
